(ns practitest.frontend.export-svg
  (:require [goog.string :refer [format]]
            [goog.string.format]))

(def print-html-template
  "HTML template for printing SVG. Format args: title, heading, svg-data"
  (str "<!DOCTYPE html>"
       "<html>"
       "<head>"
       "  <title>%s</title>"
       "  <style>"
       "    body { margin: 0; padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; box-sizing: border-box; }"
       "    h1 { font-family: sans-serif; font-size: 16px; margin-bottom: 10px; flex-shrink: 0; }"
       "    svg { width: 100%%; height: auto; }"
       "    @media print { body { height: 100vh; } svg { max-width: 100%%; max-height: 90vh; } }"
       "  </style>"
       "</head>"
       "<body>"
       "  <h1>%s</h1>"
       "  %s"
       "</body>"
       "</html>"))

(defn serialize-svg
  "Serialize a prepared SVG clone to string. 
   Expects width/height attributes to be set (by exporter)."
  [svg-element]
  {:svg-data (.serializeToString (js/XMLSerializer.) svg-element)
   :width    (js/parseFloat (.getAttribute svg-element "width"))
   :height   (js/parseFloat (.getAttribute svg-element "height"))})

(defn svg->base64
  "Convert SVG data string to base64 data URL."
  [svg-data]
  (str "data:image/svg+xml;base64,"
       (js/btoa (js/unescape (js/encodeURIComponent svg-data)))))

(defn trigger-download
  "Trigger file download via temporary link element."
  [data-url filename]
  (let [link (.createElement js/document "a")]
    (set! (.-download link) filename)
    (set! (.-href link) data-url)
    (.click link)))

(defn print-svg
  "Open a new window with SVG and trigger browser print dialog."
  [{:keys [svg-element title]}]
  (when svg-element
    (let [{:keys [svg-data]} (serialize-svg svg-element)
          print-win          (.open js/window "" "_blank")
          html               (format print-html-template
                                     (or title "Chart")
                                     title
                                     svg-data)]
      (doto (.-document print-win)
        (.write html)
        (.close))
      (js/setTimeout #(.print print-win) 100))))

(defn svg->image
  "Convert SVG element to image data URL using Canvas API.
   Returns a Promise that resolves with the data URL.
   Supports PNG and JPEG formats. JPEG accepts optional quality (0-1)."
  [{:keys [svg-element scale mime-type quality]
    :or   {scale 2 mime-type "image/png"}}]
  (js/Promise.
   (fn [resolve reject]
     (if-not svg-element
       (reject (js/Error. "No SVG element provided"))
       (let [{:keys [svg-data width height]} (serialize-svg svg-element)
             canvas (.createElement js/document "canvas")
             ctx    (.getContext canvas "2d")
             img    (js/Image.)]
         (set! (.-width canvas) (* width scale))
         (set! (.-height canvas) (* height scale))
         (.scale ctx scale scale)
         (set! (.-fillStyle ctx) "white")
         (.fillRect ctx 0 0 width height)
         (set! (.-onload img)
               #(do (.drawImage ctx img 0 0 width height)
                    (resolve
                     (if quality
                       (.toDataURL canvas mime-type quality)
                       (.toDataURL canvas mime-type)))))
         (set! (.-onerror img) #(reject (js/Error. "Failed to load SVG")))
         (set! (.-src img) (svg->base64 svg-data)))))))

(defn svg->png
  "Convert SVG element to PNG data URL. Returns a Promise."
  [{:keys [svg-element scale]
    :or   {scale 2}}]
  (svg->image {:svg-element svg-element
               :scale       scale
               :mime-type   "image/png"}))

(defn svg->jpeg
  "Convert SVG element to JPEG data URL. Returns a Promise."
  [{:keys [svg-element scale quality]
    :or   {scale 2 quality 0.92}}]
  (svg->image {:svg-element svg-element
               :scale       scale
               :mime-type   "image/jpeg"
               :quality     quality}))

(defn svg->svg
  "Convert SVG element to SVG data URL. Returns a Promise."
  [{:keys [svg-element]}]
  (js/Promise.
   (fn [resolve reject]
     (if-not svg-element
       (reject (js/Error. "No SVG element provided"))
       (let [{:keys [svg-data]} (serialize-svg svg-element)]
         (resolve (svg->base64 svg-data)))))))

(def format->exporter
  {:svg  svg->svg
   :png  svg->png
   :jpeg svg->jpeg})
